<template>
	<div
		class="cm-list-filter-chips"
		:class="[
			className,
			{
				open:
					chips.length > 0 ||
					searchChip ||
					storeChip ||
					priceChip ||
					deliveryChip,
			},
		]"
	>
		<div class="card-body" :class="classNameBody">
			<div class="cm-filter-chips d-flex flex-wrap">
				<transition-group name="chips">
					<button
						v-if="priceChip"
						class="cm-filter-chip-btn filter-chip"
						:class="
							this.$store.state.price.filter === 'leasing'
								? 'secondary'
								: 'finance'
						"
						@click="deletePriceChip()"
					>
						{{ priceChip }} <i class="mdi mdi-close"></i>
					</button>
					<button
						v-if="deliveryChip"
						class="cm-filter-chip-btn filter-chip"
						@click="deleteDeliveryChip()"
					>
						Sofort verfügbar <i class="mdi mdi-close"></i>
					</button>
					<button
						v-if="storeChip"
						class="cm-filter-chip-btn filter-chip"
						@click="deleteStoreChip()"
					>
						{{ storeChip }} <i class="mdi mdi-close"></i>
					</button>
					<button
						v-if="searchChip"
						class="cm-filter-chip-btn filter-chip"
						@click="deleteSearchChip()"
					>
						{{ searchChip }} <i class="mdi mdi-close"></i>
					</button>
					<template v-for="chip in chips" :key="chip.adPropertyKey">
						<button
							class="cm-filter-chip-btn filter-chip"
							@click="deleteChip(chip.adPropertyKey)"
						>
							<template v-if="chip.adPropertyValue === true">
								{{ chip.adPropertyLabel }} <i class="mdi mdi-close"></i>
							</template>
							<template
								v-else-if="
									chip.adPropertyKey ===
										'range-from-price-consumerPriceGross' ||
									chip.adPropertyKey ===
										'range-till-price-consumerPriceGross' ||
									chip.adPropertyKey ===
										'range-from-financing-monthlyInstallment' ||
									chip.adPropertyKey ===
										'range-till-financing-monthlyInstallment' ||
									chip.adPropertyKey === 'range-from-leasingGrossRate' ||
									chip.adPropertyKey === 'range-till-leasingGrossRate'
								"
							>
								{{ chip.adPropertyLabel }}
								{{ getPrice(chip.adPropertyValue) }} €<i
									class="mdi mdi-close"
								></i>
							</template>
							<template
								v-else-if="
									chip.adPropertyKey === 'range-from-power' ||
									chip.adPropertyKey === 'range-till-power'
								"
							>
								{{ chip.adPropertyLabel }}
								{{ getCarPs(chip.adPropertyValue) }} Ps ({{
									chip.adPropertyValue
								}}
								kW)<i class="mdi mdi-close"></i>
							</template>
							<template
								v-else-if="
									chip.adPropertyKey === 'range-from-mileage' ||
									chip.adPropertyKey === 'range-till-mileage'
								"
							>
								{{ chip.adPropertyLabel }}
								{{ getPrice(chip.adPropertyValue) }} Km<i
									class="mdi mdi-close"
								></i>
							</template>
							<template v-else>
								{{ chip.adPropertyLabel }}: {{ chip.adPropertyText }}
								<i class="mdi mdi-close"></i>
							</template>
						</button>
					</template>
					<button
						type="button"
						class="filter-chip cm-filter-chip-reset"
						@click="deleteAllChips()"
						v-if="chips.length > 0"
					>
						Alle Filter entfernen <i class="mdi mdi-close"></i>
					</button>
				</transition-group>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'
import HelperPlugin from '@/plugins/HelperPlugin'

export default {
	name: 'ListFilterChips',
	props: {
		refData: Object,
		filters: Object,
		className: {
			type: String,
			default: '',
		},
		classNameBody: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			loaded: '',
		}
	},
	computed: {
		chips() {
			let filterState = store.state.filterItems

			if (filterState) {
				let filterChips = []
				for (let item in filterState) {
					let addFilter = {
						adPropertyKey: filterState[item].adPropertyKey,
						adPropertyValue: filterState[item].adPropertyValue,
						adPropertyLabel: this.refData[filterState[item].adPropertyKey],
						adPropertyText: this.refData[filterState[item].adPropertyValue],
					}
					filterChips.push(addFilter)
				}
				return filterChips
			} else {
				return null
			}
		},
		searchChip() {
			return store.state.search ? 'Suchtext: ' + store.state.search : false
		},
		storeChip() {
			return store.state.storeId
				? 'Filiale: ' + this.refData[store.state.storeId]
				: false
		},
		deliveryChip() {
			return store.state.delivery ? 'Sofort verfügbar' : false
		},
		priceChip() {
			if (store.state.price.filter === 'finance') {
				return 'Finanzierungsangebote'
			} else if (store.state.price.filter === 'leasing') {
				return 'Leasingangebote'
			} else {
				return false
			}
		},
	},
	methods: {
		deleteChip(selectedKey) {
			store.commit('deleteFilter', selectedKey)
			//console.log(store.state)
			this.$emit('updateFilter')
		},
		deleteSearchChip() {
			store.commit('updateSearch', '')
			this.$emit('updateFilter')
		},
		deleteStoreChip() {
			store.commit('setStore', false)
			this.$emit('updateFilter')
		},
		deleteDeliveryChip() {
			store.state.delivery = ''
			this.$emit('updateFilter')
		},
		deletePriceChip() {
			store.commit('deletePrice')
			this.$emit('updateFilter')
		},
		deleteAllChips() {
			store.commit('deleteAllFilter')
			this.$emit('updateFilter')
		},
	},
	created() {},
}
</script>

<style lang="scss">
.cm-list-filter-chips {
	opacity: 0;
	overflow: hidden;
	transition: all 0.3s ease-out;
	position: relative;
	margin-top: -50px;
	transition-delay: 0.2s;
	z-index: auto;
	> div {
		min-height: 50px;
	}
	&.open {
		//top: 0;
		margin-top: 0;
		opacity: 1;
	}
}

.cm-filter-chips {
	width: 100%;
	position: relative;
	min-height: 32px;
	//margin-bottom: $px12;

	.cm-filter-chip-btn {
		overflow: hidden;
		border: none;
		margin-bottom: $px4;
		margin-right: $px4;
		background-color: $dark;
		border-radius: 15px;
		font-size: $px14;
		color: $light;
		font-weight: 400;
		padding-left: 18px;
		padding-right: 14px;

		i {
			margin-left: 3px;
		}

		&:hover {
			text-decoration: line-through;

			i {
				color: $danger;
			}
		}

		&.finance {
			background-color: $finance;
		}

		&.secondary {
			background-color: $secondary;
		}
	}

	.cm-filter-chip-reset {
		overflow: hidden;
		margin-bottom: $px4;
		padding-left: 18px;
		padding-right: 14px;
		background-color: $gray-300;
		border: none;
		font-size: $px14;
		border-radius: 15px;
		font-weight: 400;

		&:hover {
			text-decoration: underline;
		}
	}
}

.filter-chip {
	height: 30px;
	position: relative;
}

.chips-enter-active,
.chips-leave-active {
	position: relative;
	transition: all 0.2s ease-out;
}

.chips-enter-from {
	opacity: 0;
	transform: scale(1.3);
}

.chips-leave-to {
	background-color: $primary !important;
	opacity: 0;
	transform: scale(0.1);
}

/*.slide-from-top-enter-active,
.slide-from-top-leave-active {
  position: relative;
  transition: all 0.25s;
  height: auto;
  opacity: 1;
  transform: scaleY(1);
}

.slide-from-top-enter-from {
  transform: scaleY(0.1);
  opacity: 0;
}

.slide-from-top-leave-to {
  transform: scaleY(0.1);
  opacity: 0;
}*/
</style>
